import { PaApi, baseOpts, processSuccess } from '@/services/PaApi'

export const PurchasableItemModule = {
  namespaced: true,

  state: {
    loading: false,
    found_purchasable_items: [],
    purchasable_item: {},
    purchasable_items: []
  },

  actions: {
    async getPurchasableItems ({ commit, state }) {
      commit('setLoading', true)

      await PaApi().get(
        '/purchasable_items?page[size]=1000&page[order_by]=name'
      ).then((resp) => {
        commit('storeItems', resp)
      }).finally(() => {
        commit('setLoading', false)
      })
    },

    async search ({ commit, state }, query) {
      return PaApi().post(
        '/admin/purchasable_items/search', {
          query: query.query,
          subscriptions: query.subscriptions
        }
      ).then((resp) => {
        commit('storeFoundItems', resp)
        return resp
      }).finally(() => {
        commit('setLoading', false)
      })
    }
  },

  mutations: {
    setLoading (state, bool) {
      state.loading = bool
    },

    storeFoundItems (state, payload) {
      state.found_purchasable_items = processSuccess(payload, baseOpts)
    },

    storeItems (state, payload) {
      state.purchasable_items = processSuccess(payload, baseOpts)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/PurchasableItemModule.js